import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { FileDropperImageField } from 'lib/form/file-dropper/file-dropper-image.style';

type ImageContainerProps = {
  $fullBorderRadius?: boolean;
};

export const ImageContainer = styled.div<ImageContainerProps>`
  height: 100%;
  position: relative;
  border-radius: ${({ $fullBorderRadius }) =>
    $fullBorderRadius
      ? rem(borderRadius8)
      : `${rem(borderRadius8)} ${rem(borderRadius8)} 0 0`};
`;

export const ImageCreateFieldWrapper = styled.div`
  height: 100%;

  ${FileDropperImageField} {
    height: 100%;
  }
`;

export const ImageFillWrapper = styled.div`
  border-radius: ${rem(borderRadius8)};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;

  picture {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    img {
      display: block;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
`;

export const ImageViewWrapper = styled.div`
  border-radius: ${rem(borderRadius8)};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;

  picture {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    img {
      display: block;
      height: 100%;
      object-fit: contain;
      opacity: 1;
    }
  }
`;

export const ImageFigure = styled.figure`
  margin: 0;
`;
